import { Component, DoCheck, ElementRef, EventEmitter, HostListener, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
// import { element } from 'protractor';

@Component({
  selector: 'app-navigation-tab',
  templateUrl: './navigation-tab.component.html',
  styleUrls: ['./navigation-tab.component.scss'],
})
export class NavigationTabComponent implements OnInit {

  @Input() tabConfig: NavigationTabConfig[] = [];
  @Input() loading: boolean = false;
  @Input() fireInitialEvent: boolean = true;
  @Output() onTabChanged: EventEmitter<{
    tab: {
      title: string,
      index: number,
    },
    subtab: {
      title: string,
      index: number,
    },
  }> = new EventEmitter();

  @Input() selectedTabIndex: number = 0;
  @Input() selectedViewIndex: number = 0;
  @Input() selectedSubTabIndex: number = 0;

  selectedSubTabs: string[] = [];

  constructor() { }

  ngOnInit(): void {
    this.getSelectedSubTabs(this.selectedTabIndex);
    if (this.fireInitialEvent) {
      this.emitValues();
    }
  }

  changeTab(index: number): void {
    this.selectedViewIndex = index;
    if (this.tabConfig[index].subTabs != null) {
      this.getSelectedSubTabs(index);
    } else {
      this.selectedTabIndex = index;
      this.emitValues();
    }
  }

  changeSubTab(index: number): void {
    if (index == this.selectedSubTabIndex && this.selectedViewIndex == this.selectedTabIndex) {
      return;
    }
    this.selectedSubTabIndex = index;
    this.selectedTabIndex = this.selectedViewIndex;
    this.emitValues();
  }

  getSelectedSubTabs(index: number): void {
    this.selectedSubTabs = [];
    if (this.tabConfig[index].subTabs == null) {
      return;
    }

    this.selectedSubTabs = (this.tabConfig?.[index]?.subTabs?.filter(tab => {
      return tab.visible !== false;
    }) ?? []).map(elem => elem.title);
  }

  //Only works this way. Storing it in an object was breaking it.
  getTabs(): NavigationTabConfig[] {
    return this.tabConfig.filter(elem => elem.visible !== false);
  }

  private emitValues(): void {
    this.onTabChanged.emit({
      tab: {
        title: this.tabConfig[this.selectedTabIndex].title,
        index: this.selectedTabIndex
      },
      subtab: {
        title: this.selectedSubTabs[this.selectedSubTabIndex],
        index: this.selectedTabIndex
      }
    });
  }
}

export class NavigationTabConfig {
  title: string;
  subTabs?: NavigationTabConfig[];
  visible?: boolean;
}
